export function translation(keyword, translationCache) {
  return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
}
